import React, { Component } from 'react'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import AwsConfig from '../../Config/AwsConfig'
import Preview from './Preview'
import { Button, Modal } from 'react-bootstrap'
import ImageOptions from './ImageOptions'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import CompressContentImage from '../../Services/Mutations/compressContentImage'

class InAppBrowserContent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			croppedImage: '',
			src: null,
			crop: {
				aspect: 16 / 9,
			},
			coverStoryTitle: '',
			link: '',
			linkText: '',
			displayTitleBackground: false,
			textColorOptions: [
				{ item: 'white', id: 1, value: '#ffffff' },
				{ item: 'black', id: 2, value: '#000000' },
				{ item: 'grey', id: 3, value: '#bdbdbd' },
			],
			selectedTextColorOption: '#ffffff',
			contentPosition: '50',
			titleOptionsVisibility: false,
			callPermissions: 'initial',
			coverStoryImages: [],
			expanded: true,
			expandedImage: null,
			files: [],
			youtubeID: '',
			selectedtype: 'Image',
			urlType: 'Instagram',
			watchType: 'Off',
			instagramLink: '',
			youtubeLink: '',
			twitterLink: '',
			websiteLink: '',
			styleType: 'Custom',
			imageSizeLimitModal: false,
		}
	}

	handleTitle = (e) => {
		const title = e.target.value
		this.setState({ coverStoryTitle: title })
		this.props.updateChildElements(
			`coverStoryTitle_${this.props.contentSelectedLangVal}`,
			title,
			'InAppBrowser'
		)
	}
	handleStyleType = (style) => {
		this.setState({ styleType: style })
		this.props.updateChildElements('styleType', style, 'InAppBrowser')
	}
	verifyLink = (link) => {
		const regex1 = new RegExp(
			'^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?'
		)
		return !regex1.test(link)
	}

	handleLink = (e) => {
		const link = e.target.value
		this.setState({ link: link, invalidURL: this.verifyLink(link) })
		this.props.updateChildElements('link', link, 'InAppBrowser')
	}
	handleLinkText = (e) => {
		const linkText = e.target.value

		this.setState({ linkText: linkText })
		this.props.updateChildElements('linkText', linkText, 'InAppBrowser')
	}

	handleCoverStoryImages = (images) => {
		this.setState({ coverStoryImages: images })
		const imagesArr = []
		images.filter((item) => {
			const obj = {
				image: item.key ? item.key : item.image,
				copyRight: item.copyRight,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
			}
			imagesArr.push(obj)
		})
		this.props.updateChildElements('coverStoryImages', imagesArr, 'InAppBrowser')
		this.props.updateChildElements('coverStoryOriginalImages', images, 'InAppBrowser')
	}

	handleCoverStoryImagesError = () => {
		return !this.state.coverStoryImages.length
	}

	hastitleError = () => {
		return !this.state.coverStoryTitle
	}

	hasLinkError = () => {
		return !this.state.link
	}
	handleTextColorRadioButton = (item) => {
		this.setState({ selectedTextColorOption: item.value })
		this.props.updateChildElements('textColor', item.value, 'InAppBrowser')
	}
	handleShowTitleBackground = () => {
		this.setState(
			{
				displayTitleBackground: !this.state.displayTitleBackground,
			},
			() => {
				this.props.updateChildElements(
					'backGroundTitle',
					this.state.displayTitleBackground,
					'InAppBrowser'
				)
			}
		)
	}
	handleContentPosition = (e) => {
		const contentPosition = e.target.value

		this.setState({ contentPosition: contentPosition })
		this.props.updateChildElements('contentTitlePosition', contentPosition, 'InAppBrowser')
	}

	toggleCopyRightSwitch = (key) => {
		const { coverStoryImages } = this.state
		coverStoryImages.filter((item) => {
			if (item.key == key) {
				item.copyRight = !item.copyRight
			}
		})
		this.handleCoverStoryImages(coverStoryImages)
	}

	handleCopyrightText = (key, e) => {
		const text = e.target.value
		const { coverStoryImages } = this.state
		coverStoryImages.filter((item) => {
			if (item.key == key) {
				item.copyRightText = text
			}
		})
		this.handleCoverStoryImages(coverStoryImages)
	}
	handleCopyrightType = (key, copyrightPrefix) => {
		const { coverStoryImages } = this.state
		coverStoryImages.filter((item) => {
			if (item.key == key) {
				item.copyRightText = copyrightPrefix
			}
		})
		this.handleCoverStoryImages(coverStoryImages)
	}

	toggleShareImageSwitch = (key) => {
		const { coverStoryImages } = this.state
		coverStoryImages.filter((item) => {
			if (item.key == key) {
				item.shareImage = !item.shareImage
			}
		})
		this.handleCoverStoryImages(coverStoryImages)
	}
	GetDate = () => {
		return (
			new Date().getFullYear() +
			'' +
			('0' + (new Date().getMonth() + 1)).slice(-2) +
			('0' + new Date().getDate()).slice(-2)
		)
	}

	handleImageChange = async (e) => {
		const files = e.target.files
		e.preventDefault()
		const images = []
		const selectedImagesPaths = []
		for (let i = 0; i < files.length; i++) {
			let file = files[i]
			let reader = new FileReader()
			reader.onloadend = async () => {
				let file = files[i]
				const randomId = await uuidv4()
				const key = 'public/' + this.GetDate() + '/contents/' + randomId
				const params = {
					key: key,
					mimeType: file.type,
				}
				const preSignedURLObject = await getPreSignedURLForImageService(params)
				const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
				const signedURL = signedURLObject.data['url']
				try {
					const formData = new FormData()
					Object.keys(signedURLObject.data.fields).forEach((key) => {
						formData.append(key, signedURLObject.data.fields[key])
					})
					// Actual file has to be appended last.
					formData.append('file', file)

					const response = await axios({
						method: 'post',
						url: signedURL,
						data: formData,
						headers: { 'Content-Type': 'multipart/form-data' },
					})
					if (response.status) {
						const imageObj = {
							key: key,
							imageValue: reader.result,

							copyRight: false,
							copyRightText: '',
							shareImage: false,
						}
						const { coverStoryImages } = this.state
						coverStoryImages.push(imageObj)
						this.handleCoverStoryImages(coverStoryImages)
					}
				} catch (err) {
					console.warn(err, 'err')
				}
			}
			reader.readAsDataURL(file)
		}
	}
	removeCoverStoryImage = (imageIndex) => {
		const images = this.state.coverStoryImages
		images.splice(imageIndex, 1)
		this.handleCoverStoryImages(images)
	}
	// hideImageSizeLimitModal = () => {
	// 	this.setState({
	// 		imageSizeLimitModal: false,
	// 	})
	// }
	onSelectFile = (e) => {
		let pngImageExists = false
		pngImageExists = e?.target?.files[0]?.type?.includes('png')
		if (!pngImageExists) {
			if (e.target.files && e.target.files.length > 0) {
				const reader = new FileReader()
				reader.addEventListener('load', () => this.setState({ src: reader.result }))
				reader.readAsDataURL(e.target.files[0])
				this.setState({
					coverStoryImages: [],
					selectedImage: e.target.files[0],
					crop: false,
					croppedImageUrl: '',
					croppedImage: '',
					imageSizeLimitModal: false,
				})
				// reader.onloadend = function () {
				//   var base64data = reader.result
				// }
			}
		} else {
			this.setState({ imageSizeLimitModal: true })
		}
	}

	// If you setState the crop in here you should return false.
	onImageLoaded = (image) => {
		this.imageRef = image
	}

	onCropComplete = (crop) => {
		this.makeClientCrop(crop)
	}

	onCropChange = (crop, percentCrop) => {
		// You could also use percentCrop:
		// this.setState({ crop: percentCrop });
		this.setState({ crop })
	}

	async makeClientCrop(crop) {
		if (this.imageRef && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')

			this.setState({ croppedImageUrl })
		}
	}
	removeSelectedImage = () => {
		this.setState({
			coverStoryImages: [],
			src: null,
			crop: false,
			croppedImageUrl: '',
			croppedImage: '',
		})
		this.props.updateChildElements('coverStoryImages', [], 'InAppBrowser')
		this.props.updateChildElements('coverStoryOriginalImages', [], 'InAppBrowser')
	}
	uploadSelectedImage = async (crop) => {
		const randomId = await uuidv4()
		const key = 'public/' + this.GetDate() + '/contents/' + randomId
		const params = {
			key: key,
			mimeType: this.state.selectedImage.type,
		}
		const preSignedURLObject = await getPreSignedURLForImageService(params)
		const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
		const signedURL = signedURLObject.data['url']
		try {
			const formData = new FormData()
			Object.keys(signedURLObject.data.fields).forEach((key) => {
				formData.append(key, signedURLObject.data.fields[key])
			})
			// Actual file has to be appended last.
			if (crop) {
				formData.append('file', this.state.croppedImage)
			} else {
				formData.append('file', this.state.selectedImage)
			}
			const response = await axios({
				method: 'post',
				url: signedURL,
				data: formData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			if (response.status) {
				const imageObj = {
					key: key,
					imageValue: this.state.src,
					copyRight: false,
					copyRightText: '',
					shareImage: false,
				}
				if (response.status) {
					const imageObj = {
						imageValue: this.state.croppedImageUrl ? this.state.croppedImageUrl : this.state.src,
						key: key,
						copyRight: false,
						copyRightText: '',
						shareImage: false,
					}
					const { coverStoryImages } = this.state
					coverStoryImages.push(imageObj)
					const input = {
						imagePath: imageObj.key
					}
					console.log(input, "======compressImageinput")
					if (input != undefined && input != null && input.imagePath != null && input.imagePath != undefined && input.imagePath != "") {
						const response = await CompressContentImage(input)
						console.log(response, "response compress image ==========")
					}
					this.handleCoverStoryImages(coverStoryImages)
				}
			}
		} catch (err) {
			console.warn(err, 'err')
		}
	}
	getCroppedImg(image, crop, fileName) {
		const canvas = document.createElement('canvas')
		const pixelRatio = window.devicePixelRatio
		const scaleX = image.naturalWidth / image.width
		const scaleY = image.naturalHeight / image.height
		const ctx = canvas.getContext('2d')

		canvas.width = crop.width * pixelRatio * scaleX
		canvas.height = crop.height * pixelRatio * scaleY

		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
		ctx.imageSmoothingQuality = 'high'

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width * scaleX,
			crop.height * scaleY
		)

		return new Promise((resolve, reject) => {
			canvas.toBlob(
				(blob) => {
					if (!blob) {
						//reject(new Error('Canvas is empty'));
						console.error('Canvas is empty')
						return
					}
					blob.name = fileName
					window.URL.revokeObjectURL(this.fileUrl)
					this.fileUrl = window.URL.createObjectURL(blob)
					this.setState({ croppedImage: blob })
					resolve(this.fileUrl)
				},
				'image/jpeg',
				1
			)
		})
	}
	componentDidMount() {
		const { editContent, contentSelectedLangVal } = this.props
		const { inAppBrowserDetails } = this.props

		if (editContent) {
			this.setState({
				coverStoryTitle: inAppBrowserDetails[`coverStoryTitle_${contentSelectedLangVal}`],
				link: inAppBrowserDetails.link ? inAppBrowserDetails.link : '',
				linkText: inAppBrowserDetails.linkText ? inAppBrowserDetails.linkText : '',

				selectedTextColorOption: inAppBrowserDetails.textColor
					? inAppBrowserDetails.textColor
					: '#fffff',
				contentTitlePosition: inAppBrowserDetails.contentTitlePosition
					? inAppBrowserDetails.contentTitlePosition
					: 50,
				displayTitleBackground: inAppBrowserDetails.backGroundTitle
					? inAppBrowserDetails.backGroundTitle
					: false,
				styleType: inAppBrowserDetails.styleType ? inAppBrowserDetails.styleType : 'Custom',
				src: inAppBrowserDetails.coverStoryImages
					? inAppBrowserDetails.coverStoryImages[0].image
					: '',
				coverStoryImages: inAppBrowserDetails.coverStoryImages
					? inAppBrowserDetails.coverStoryImages
					: [],
			})
		}
	}
	componentDidUpdate = (prevProps) => {
		if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal) {
			const { editContent, contentSelectedLangVal } = this.props
			const { inAppBrowserDetails } = this.props

			if (editContent) {
				this.setState({
					coverStoryTitle: inAppBrowserDetails[`coverStoryTitle_${contentSelectedLangVal}`],
					link: inAppBrowserDetails.link ? inAppBrowserDetails.link : '',
					linkText: inAppBrowserDetails.linkText ? inAppBrowserDetails.linkText : '',

					selectedTextColorOption: inAppBrowserDetails.textColor
						? inAppBrowserDetails.textColor
						: '#fffff',
					contentTitlePosition: inAppBrowserDetails.contentTitlePosition
						? inAppBrowserDetails.contentTitlePosition
						: 50,
					displayTitleBackground: inAppBrowserDetails.backGroundTitle
						? inAppBrowserDetails.backGroundTitle
						: false,
					styleType: inAppBrowserDetails.styleType ? inAppBrowserDetails.styleType : 'Custom',
					src: inAppBrowserDetails.coverStoryImages
						? inAppBrowserDetails.coverStoryImages[0].image
						: '',
					coverStoryImages: inAppBrowserDetails.coverStoryImages
						? inAppBrowserDetails.coverStoryImages
						: [],
				})
			}
		}
	}
	renderTitleOptions = () => {
		const { textColorOptions, selectedTextColorOption, contentPosition } = this.state
		return (
			<details>
				<summary>Title Options</summary>
				<div class='justify-content-center' style={{ display: 'flex' }}>
					{textColorOptions.map((item, index) => (
						<div key={index}>
							{selectedTextColorOption == item.value ? (
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
										borderColor: 'red',
										borderStyle: 'solid',
									}}
									onClick={() => this.handleTextColorRadioButton(item)}
								></div>
							) : (
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
									}}
									onClick={() => this.handleTextColorRadioButton(item)}
								></div>
							)}
						</div>
					))}
				</div>
				<div class='col-md-12'>
					<input
						type='checkbox'
						onChange={this.handleShowTitleBackground}
						checked={this.state.displayTitleBackground}
					></input>
					<text for='text'> Show Title Background </text>
				</div>
				<div>
					<text for='text'>Content position from top (%) </text>
					<input
						type='number'
						onChange={(value) => {
							this.handleContentPosition(value)
						}}
						value={contentPosition}
						placeholder='Please Enter Title Position'
					></input>
				</div>
			</details>
		)
	}
	render() {
		const {
			coverStoryTitle,
			link,
			linkText,
			invalidURL,
			styleType,
			coverStoryImages,
			crop,
			croppedImageUrl,
			src,
		} = this.state
		return (
			<div>
				<details>
					<summary>InappBrowser Details</summary>
					<div class='row'>
						<text for='text'>Title : </text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleTitle(value)
							}}
							value={coverStoryTitle}
							placeholder='Please Enter  Title'
						></textarea>
						{!coverStoryTitle ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Title Cannot Be Empty
							</text>
						) : null}
					</div>

					<text for='text'>Style Type : </text>
					<div style={{ marginRight: 10 }}>
						<input
							value={styleType}
							type='radio'
							checked={styleType == 'Custom'}
							onChange={() => {
								this.handleStyleType('Custom')
							}}
						></input>
						<text for={'Custom'}>{'Custom'}</text>
					</div>

					<div>
						<input
							value={styleType}
							type='radio'
							checked={styleType == 'OverLay'}
							onChange={() => {
								this.handleStyleType('OverLay')
							}}
						></input>
						<text for={'OverLay'}>{'OverLay'}</text>
					</div>
					{styleType == 'Custom' ? this.renderTitleOptions() : null}
					<div>
						<text for='text'>Link : </text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleLink(value)
							}}
							value={link}
							placeholder='Please Enter  Link'
						></textarea>
					</div>
					{!link || invalidURL ? (
						<text style={{ color: 'red', fontSize: 10 }}>Enter A Valid Url</text>
					) : null}
					<div>
						<text for='text'>Link Text : </text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleLinkText(value)
							}}
							value={linkText}
							placeholder='Please Enter  Link Text'
						></textarea>
					</div>
					{!linkText ? (
						<text style={{ color: 'red', fontSize: 10 }}>Please Enter Link Text</text>
					) : null}
					<div class='row'>
						<text for='text'>Upload Cover Story Images :</text>
						<p for='text' style={{ color: 'red', fontSize: 10 }}>
							(Only JPG and JPEG images are allowed)
						</p>
						<div className='App'>
							<div>
								<input type='file' accept=".jpg,.jpeg" onChange={this.onSelectFile} />
							</div>

							{src && !croppedImageUrl && (
								<ReactCrop
									src={src}
									crop={crop}
									ruleOfThirds
									onImageLoaded={this.onImageLoaded}
									onComplete={this.onCropComplete}
									onChange={this.onCropChange}
								/>
							)}
							{croppedImageUrl && (
								<img alt='Crop' style={{ maxWidth: '100%' }} src={croppedImageUrl} />
							)}
							{src ? (
								<button onClick={() => this.removeSelectedImage()}>Remove Image</button>
							) : null}
							{!coverStoryImages.length && src && !croppedImageUrl && (
								<button onClick={() => this.uploadSelectedImage(false)}>Upload Image</button>
							)}
						</div>
						{!coverStoryImages.length && croppedImageUrl ? (
							<button onClick={() => this.uploadSelectedImage(true)}>Upload Cropped Image</button>
						) : null}

						{coverStoryImages.length == 0 ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Please Upload Image
							</text>
						) : null}
					</div>
					<div className='imagesContainer'>
						{coverStoryImages.map((item, index) => {
							const { copyRightText, copyRight, shareImage, key } = item
							return (
								<div key={index} className='imgPreview'>
									<ImageOptions
										item={item}
										copyRight={copyRight}
										copyRightText={copyRightText}
										toggleCopyRightSwitch={(key) => this.toggleCopyRightSwitch(key)}
										handleCopyrightText={(key, text) => this.handleCopyrightText(key, text)}
										// handleCopyrightText={(key, copyrightPrefix) =>
										// 	this.handleCopyrightType(key, copyrightPrefix)
										// }
										shareImage={shareImage}
										toggleShareImageSwitch={(key) => this.toggleShareImageSwitch(key)}
									/>
								</div>
							)
						})}
					</div>
				</details>
				<label for='text' style={{ color: 'red', fontSize: 10 }}>
					{this.state.imageSizeLimitModal ? "Only JPG,JPEG Images are allowed" : ""}
				</label>
				{/* <Modal show={this.state.imageSizeLimitModal} onHide={() => this.hideImageSizeLimitModal()}>
					<Modal.Body>
						<div className='row'>
							<text>Maximum allowed Image size is 900 Kb</text>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.hideImageSizeLimitModal()}>Ok</Button>
					</Modal.Footer>
				</Modal> */}
			</div>
		)
	}
}

export default InAppBrowserContent
